module.exports = __webpack_public_path__ + "static/img/qsb.29d0e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/qsb.png
// module id = H5yx
// module chunks = 93